export class User {

  static ROLE_USER = 'ROLE_USER';
  static ROLE_ADMIN = 'ROLE_ADMIN';

  constructor(
    public id: number,
    public username: string,
    public firstname: string,
    public lastname: string,
    public roles: any,
    public permissions: any,
    public type: number
  ) {}
}
